<!--用户管理新建档案详情页面-->
<template>
<a-modal 
    v-model="visible" 
    :title="title" 
    :width="width" 
    switchFullscreen
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <template slot="footer">
        <a-button @click="handleCancel">{{ $t('关闭') }}</a-button>
    </template>
  <a-spin :spinning="confirmLoading">
      <a-tabs v-model="activeKey" @change="changeTab">
        <a-tab-pane key="1" :tab="$t('用户详细信息')">
            <!--
          <div>
            <span style="font-size:16px">当前用户状态:</span>
            <a-button :class="queryUserDetailInfoById.userState == 1?'normalbg-status':queryUserDetailInfoById.userState == 0?'unactivebg-status':''" style="margin-left:18px">
              {{queryUserDetailInfoById.userState==1?'已激活':queryUserDetailInfoById.userState==0?'未激活':''}}
            </a-button>
          </div>
          -->
          <div class="form-contain">
            <a-divider orientation="left">
              {{ $t('用户信息') }}
            </a-divider>
            <detail-list :col="4">
              <detail-list-item :term="$t('用户姓名')">{{this.queryUserDetailInfoById.userName}}</detail-list-item>
              <detail-list-item :term="$t('用户编号')">{{this.queryUserDetailInfoById.userId}}</detail-list-item>
              <!-- <detail-list-item term="区域名称">{{this.queryUserDetailInfoById.userAreaName}}</detail-list-item>
              <detail-list-item term="用户地址">{{this.queryUserDetailInfoById.userAddr}}</detail-list-item> -->
              <detail-list-item :term="$t('用户地址')" style="width: 50%;">{{this.queryUserDetailInfoById.userAreaName.slice(this.queryUserDetailInfoById.userAreaName.indexOf('-')+1,this.queryUserDetailInfoById.userAreaName.length)+'-'+this.queryUserDetailInfoById.userAddr}}</detail-list-item>
              <detail-list-item :term="$t('表安装地址')">{{this.queryUserDetailInfoById.userMeterAddr}}</detail-list-item>
              <detail-list-item :term="$t('手机号码')">{{this.queryUserDetailInfoById.userPhone}}</detail-list-item>
              <detail-list-item :term="$t('身份证号')">{{this.queryUserDetailInfoById.userIdNumber}}</detail-list-item>
              <detail-list-item :term="$t('身份类型')">{{this.queryUserDetailInfoById.userIdType== 1?$t('自然人'): $t('企业')}}</detail-list-item>
              <detail-list-item :term="$t('建档日期')">{{this.queryUserDetailInfoById.createTime}}</detail-list-item>
              <detail-list-item :term="$t('是否制卡')" v-if="model.meterType == 'WN100'">{{queryUserDetailInfoById.userHasCard== 1?$t('已制卡'): $t('未制卡')}}</detail-list-item>
              <detail-list-item :term="$t('激活时间')">{{queryUserDetailInfoById.userActivateTime}}</detail-list-item>
              <detail-list-item :term="$t('激活人')">{{queryUserDetailInfoById.userActivateBy}}</detail-list-item>
            </detail-list>
            <a-divider orientation="left" v-if="this.queryUserDetailInfoById.userState==1">
              {{ $t('实时账户信息') }}
            </a-divider>
            <detail-list v-if="this.queryUserDetailInfoById.userState==1">
              <detail-list-item :term="$t('当前余额(元)')">{{this.queryUserDetailInfoById.userAccountNum}}</detail-list-item>
              <detail-list-item :term="$t('结算累计流量(m³)')">{{this.queryUserDetailInfoById.userCalNum}}</detail-list-item>
              <detail-list-item :term="$t('充值次数')">{{this.queryUserDetailInfoById.userPayTimes}}</detail-list-item>
              <detail-list-item :term="$t('当前价格信息')">{{this.queryUserDetailInfoById.wtName}}({{this.queryUserDetailInfoById.wtTotalPrice}}{{$t('元')}})</detail-list-item>
              <detail-list-item :term="$t('开始计费读数(m³)')">{{this.queryUserDetailInfoById.userStartCalNum}}</detail-list-item>
              <detail-list-item :term="$t('最近更新日期')">{{this.queryUserDetailInfoById.userAccounyUpdateTime}}</detail-list-item>
            </detail-list>
            <a-divider orientation="left" v-if="this.queryUserDetailInfoById.userState==1">
              {{ $t('表具最新信息') }}
            </a-divider>
            <detail-list v-if="this.queryUserDetailInfoById.userState==1">
              <detail-list-item :term="$t('最后上报日期')">{{this.queryUserDetailInfoById.meterUpDataTime}}</detail-list-item>
              <detail-list-item :term="$t('最后上报读数')">{{this.queryUserDetailInfoById.meterTotalUse}}</detail-list-item>
              <detail-list-item :term="$t('表编号')">{{this.queryUserDetailInfoById.meterId}}</detail-list-item>
              <detail-list-item :term="$t('电池状态')">{{this.queryUserDetailInfoById.meterBatteryStatus==0?$t("正常"):this.queryUserDetailInfoById.meterBatteryStatus==1?$t("欠压"):''}}</detail-list-item>
              <detail-list-item :term="$t('阀门状态')">{{Mn100FkStatusObj[this.queryUserDetailInfoById.meterValveStatus]}}</detail-list-item>
            </detail-list>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" :tab="$t('交易记录')">
          <div class="form-contain">
            <div class="table-page-search-wrapper">
              <a-form layout="inline" @keyup.enter.native="searchQuery">
                <a-row :gutter="24">
                  <a-col :xl="12" :lg="7" :md="8" :sm="24">
                    <a-form-item :label="$t('操作类型')">
                      <a-select
                        mode="multiple"
                        v-model="genre"
                        style="width: 100%"
                        :placeholder="$t('请选择操作类型')"
                        :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}"
                        @change="handleChange"
                      >
                        <a-select-option v-for="(item,value) in payTypeObj" :value="value" :key="value">
                          {{item}}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :xl="8" :lg="7" :md="8" :sm="24">
                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                    <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                    <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                    </span>
                  </a-col>
                </a-row>
              </a-form>
            </div>
            <!-- 操作按钮区域 -->
            <div class="table-operator">
              <a-button type="primary" icon="download" @click="handleExportXlsUserPayRecord($t('交易记录'))">{{ $t('导出') }}</a-button>
            </div>
              <a-table
                :columns="PaymentRecords"
                :data-source="dataSource"
                :scroll="{x:true}"
                rowKey='id'
                size="middle"
                :loading="loading"
                :pagination="ipagination"
                @change="handleTableChange"
                class="j-table-force-nowrap"
              >
                <span slot="userPriceSlot" slot-scope="text, record">
                  <span v-if="record.userPriceName"> {{record.userPriceName}}({{record.userPriceTotal?record.userPriceTotal + $t('元'): '--'}})</span>
                  <span v-else>--</span>
                </span>
              </a-table>
          </div>
        </a-tab-pane>
        <!--
        <a-tab-pane key="3" tab="上报记录">
          <div class="form-contain">
            <a-table 
              :columns="ReportedData"
              :data-source="UpDataRecord"
              :scroll="{x:true}"
              rowKey='id'
              size="middle"
              :pagination="ipaginationreported"
              @change="handleTableChangereported"
              class="j-table-force-nowrap"
            >
            <span slot="action" slot-scope="text, record">
              <a @click="handleParticulars(record)">详情</a>
            </span>
            </a-table>
          </div>
        </a-tab-pane>
        -->
        <a-tab-pane key="3" :tab="$t('换表记录')">
          <div class="form-contain">
              <div class="table-page-search-wrapper">
              <a-form layout="inline" @keyup.enter.native="searchQueryChangeMeterRecord">
                <a-row :gutter="24">
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item :label="$t('换表原因类型')">
                        <j-dict-select-tag v-model="queryParamChangeMeter.meterChangeType" :placeholder="$t('请选择换表原因类型')" dictCode="meterChangeType" />
                    </a-form-item>
                    </a-col>
                    <a-col :xl="12" :lg="7" :md="8" :sm="24">
                        <a-form-item :label="$t('查询起止时间')">
                            <a-range-picker
                            v-model="changeMeterDate"
                            format="YYYY-MM-DD"
                            :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                            @change="onDateRangeChange"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                        <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                        <a-button type="primary" @click="searchQueryChangeMeterRecord" icon="search">{{ $t('查询') }}</a-button>
                        <a-button type="primary" @click="searchResetChangeMeterRecord" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                        </span>
                    </a-col>
                </a-row>
              </a-form>
            </div>
            <!-- 操作按钮区域 -->
            <div class="table-operator">
              <a-button type="primary" icon="download" @click="handleExportXlsChangeMeterRecord($t('换表记录'))">{{ $t('导出') }}</a-button>
            </div>
            <a-table 
              :columns="changeMeterColumn"
              :data-source="dataSource"
              :scroll="{x:true}"
              rowKey='id'
              size="middle"
              :loading="loading"
              :pagination="ipagination"
              @change="handleTableChangeMeter"
              class="j-table-force-nowrap"
            >
            <span slot="action" slot-scope="text, record">
              <a @click="handleChangeMeterModal(record)">{{ $t('详情') }}</a>
            </span>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="4" :tab="$t('过户记录')">
          <div class="form-contain">
            <!-- 操作按钮区域 -->
            <div class="table-operator">
              <a-button type="primary" icon="download" @click="handleExportXlsTransferMeterRecord($t('过户记录'))">{{ $t('导出') }}</a-button>
            </div>
            <a-table 
              :columns="transferMeterColumn"
              :data-source="dataSource"
              :scroll="{x:true}"
              rowKey='id'
              size="middle"
              :loading="loading"
              :pagination="ipagination"
              @change="handleTableChangeTransferMeter"
              class="j-table-force-nowrap"
            >
              <span slot="newWtPriceSlot" slot-scope="text, record">
                <span v-if="record.wtName"> {{record.wtName}}({{record.wtTotalPrice?record.wtTotalPrice + $t('元'): '--'}})</span>
                <span v-else>--</span>
              </span>
              <span slot="oldWtPriceSlot" slot-scope="text, record">
                <span v-if="record.oldWtName"> {{record.oldWtName}}({{record.oldWtTotalPrice?record.oldWtTotalPrice + $t('元'): '--'}})</span>
                <span v-else>--</span>
              </span>
              <span slot="action" slot-scope="text, record">
                <a @click="handletransferMeterDetail(record)">{{ $t('详情') }}</a>
              </span>
            </a-table>
          </div>
        </a-tab-pane>
        <!--
        <a-tab-pane key="5" tab="命令管理">
          <div class="form-contain">
            <a-table 
              :columns="OrderManagement"
              :data-source="dataSurce"
              :scroll="{x:true}"
              rowKey='id'
              size="middle"
              :pagination="ipagination"
              @change="handleTableChan"
              class="j-table-force-nowrap"
            >
              <span slot="action" slot-scope="text, record">
                <a @click="record.meterType=='80'?handleDetail(record):handleDetails(record)">详情</a>
              </span>
            </a-table>
          </div>
        </a-tab-pane>
        -->
        <a-tab-pane key="6" :tab="$t('扣费记录')">
          <div class="form-contain">
            <div class="table-page-search-wrapper">
              <a-form layout="inline" @keyup.enter.native="searchQueryAccountChangeRecord">
                <a-row :gutter="24">
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item :label="$t('操作类型')">
                        <a-select
                          style="width: 100%"
                          :placeholder="$t('请选择操作类型')"
                          v-model="queryParamAccountChange.accountChangeType"
                        >
                          <a-select-option v-for="(item,value) in accountChangeObj" :value="value" :key="value">
                            {{item}}
                          </a-select-option>
                        </a-select>
                    </a-form-item>
                    </a-col>
                    <a-col :xl="12" :lg="7" :md="8" :sm="24">
                        <a-form-item :label="$t('查询起止时间')">
                            <a-range-picker
                            v-model="accountChangeDate"
                            format="YYYY-MM-DD"
                            :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                            @change="onDateRangeChangeAccountChange"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                        <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                        <a-button type="primary" @click="searchQueryAccountChangeRecord" icon="search">{{ $t('查询') }}</a-button>
                        <a-button type="primary" @click="searchResetAccountChangeRecord" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                        </span>
                    </a-col>
                </a-row>
              </a-form>
            </div>
            <!-- 操作按钮区域 -->
            <div class="table-operator">
              <a-button type="primary" icon="download" @click="handleExportXlsAccountChangeRecord($t('扣费记录'))">{{ $t('导出') }}</a-button>
            </div>
            <a-table 
              :columns="accountChangeColumn"
              :data-source="dataSource"
              :scroll="{x:true}"
              rowKey='id'
              size="middle"
              :loading="loading"
              :pagination="ipagination"
              @change="handleTableChangeAccountChange"
              class="j-table-force-nowrap"
            >
            <!--
            <span slot="action" slot-scope="text, record">
            <a @click="handletransferMeterDetail(record)">详情</a>
            </span>
            -->
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="7" :tab="$t('命令服务队列')">
          <div class="form-contain">
            <a-table
              ref="table"
              size="middle"
              bordered
              rowKey="id"
              :columns="partcolumns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :loading="loading"
              :scroll="{x: true}"
              class="j-table-force-nowrap" 
              @change="handleTableChange1">
            
              <span slot="action" slot-scope="text, record">
                <a @click="handleDetail1(record)">{{ $t('详情') }}</a>
              </span>
            </a-table>
          </div>
        </a-tab-pane>
      </a-tabs>
    <meter-up-data-modal ref="upDataModal" @ok="upDataModalOk"></meter-up-data-modal>
    <partCommand-old-modal ref="modalOldForm" @ok="modalOldForm"></partCommand-old-modal>
    <partCommand-modal ref="modalForm" @ok="modalFormOk"></partCommand-modal>
    <mete-change-meter-record-modal ref="changeMeterModal"></mete-change-meter-record-modal>
    <meter-userinfo-transfer-record-modal ref="transferMeterModal"></meter-userinfo-transfer-record-modal>
    <partCommand-modal ref="modalForm1" @ok="modalFormOk"></partCommand-modal>
    <partUSCommand-modal ref="usModalForm" @ok="modalFormOk"></partUSCommand-modal>
  </a-spin>
</a-modal>
</template>

<script>
  import { getAction,downFile} from '@/api/manage'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  import { queryAreaTreeList } from '@/api/api'
  import {isUndefined,isNull,isUndefinedAndNull} from'@/utils/validate'
  import DetailList from '@/components/tools/DetailList'
  import PartCommandOldModal from '../../part/modules/PartCommandOldModal'
  import PartCommandModal from '../../part/modules/PartCommandModal'
  import MeterUpDataModal from '../../InternetDeviceManagement/modules/MeterUpDataModal'
  import MeteChangeMeterRecordModal from '@/views/meterUserRecordList/modules/MeteChangeMeterRecordModal'
  import MeterUserinfoTransferRecordModal from '@/views/meterUserRecordList/modules/MeterUserinfoTransferRecordModal'
  import { filterObj } from '@/utils/util'
  import {dataFlagObj,netTypeObj,reportStatusObj,Mn100FkStatusObj} from '@/utils/constants/protocolConstant'
  import {payWayObj,payTypeObj,meterTypeObj,accountChangeObj} from '@/utils/constants/commonConstant'
  // import PartCommandModal from '@/views/part/modules/PartCommandModal'
  import PartUSCommandModal from '@/views/part/modules/PartUSCommandModal'

  const DetailListItem = DetailList.Item
  export default {
    name: 'MeterUserinfoForm',
    components: {
      DetailList,
      DetailListItem,
      PartCommandOldModal,
      PartCommandModal,
      MeterUpDataModal,
      MeteChangeMeterRecordModal,
      MeterUserinfoTransferRecordModal,
      PartUSCommandModal
    },
    data () {
      return {
        Mn100FkStatusObj,
        meterTypeObj,
        payTypeObj,
        accountChangeObj,
        seen:false,
        treeData:[],
        genre:[],
        condition:false,
        activeKey:'1',
        defaultkey:'',
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        ipagination:{
          current: 1,
          pageSize: 8,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          total: 0
        },
        ipaginationreported:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          total: 0
        },
        ipaginationchangemeter:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          total: 0
        },
        ipaginationtransfermeter:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          total: 0
        },
        ipaginationaccountchange: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          total: 0
        },
        ipaginationmanagement:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          total: 0
        },
        ipagination1:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          total: 0
        },
        confirmLoading: false,
        UserWaterReportDay:[],
        queryUserDetailInfoById:[],
        queryParamChangeMeter: {},
        queryParamAccountChange: {},
        changeMeterDate: [],
        accountChangeDate: [],
        url: {
          add: "/jeecg-charge/meter/meterUserinfo/add",
          edit: "/jeecg-charge/meter/meterUserinfo/edit",
          queryById: "/jeecg-charge/meter/meterUserinfo/queryById",
          list: "/jeecg-charge/meter/meterUserPayRecord/list",//缴费记录
          UpDataRecord: "/jeecg-charge/meter/meterUpDataRecord/list", //上报数据
          UserWaterReportDay: "/jeecg-charge/meter/meterUserWaterReportDay/list", //日用量报表详情查询
          commandlist: "/jeecg-charge/meter/command/list", //命令管理
          queryUserDetailInfoById:'/jeecg-charge/meter/meterUserinfo/queryUserDetailInfoById', //用户详情
          changeMeterDataRecord: '/jeecg-charge/meter/meteChangeMeterRecord/list', // 换表记录
          transferMeterDataRecord: '/jeecg-charge/meter/meterUserinfoTransferRecord/list',// 过户记录
          accountChangeDataRecord: '/jeecg-charge/meter/meterUserAccountChangeRecord/list', // 扣费记录
          exportXlsUrlAccountChangeDataRecord: "/jeecg-charge/meter/meterUserAccountChangeRecord/exportXls", //扣费记录导出接口
          exportXlsUrlTransferMeterDataRecord: "/jeecg-charge/meter/meterUserinfoTransferRecord/exportXls",// 过户记录导出接口
          exportXlsUrlchangeMeterDataRecord: "/jeecg-charge/meter/meteChangeMeterRecord/exportXls",// 换表记录导出接口
          exportXlsUrlUserPayRecord: "/jeecg-charge/meter/meterUserPayRecord/exportXls",// 交易记录导出接口，
          partlist: "/jeecg-charge/model/partCommand/list",// 命令队列
        },
        title:'',
        width:1000,
        visible: false,
        disableSubmit: false,
        dataSource: [],
        loading: false,
      }
    },
    computed: {
      // i18n：列标题/校验消息使用 computed 以响应语言切换
      PaymentRecords() {
        return [
        {
          title: this.$t('表编号'),
          dataIndex: 'meterId',
          align:"center",
        },{
          title: this.$t('用户姓名'),
          dataIndex: 'userName',
          align:"center",
        },{
          title: this.$t('购买金额(元)'),
          dataIndex: 'userPayAccountNum',
          align:"center",
          customRender:(t,r,index) => {
            if(!isUndefined(r.userAccountPayType)&&[2,4,6].includes(r.userAccountPayType)) {
              return '-'+t
            }
            return t
          }
        },{
          title: this.$t('价格信息'),
          dataIndex: 'userPrice',
          align:"center",
          scopedSlots: { customRender: 'userPriceSlot' },
        },{
          title:this.$t('购买量(吨)'),
          dataIndex: 'payWaterNum',
          align:"center",
          customRender:(t,r,index) => {
            if(isUndefinedAndNull(t)) {
              return '--'
            }
            if(!isUndefined(r.userAccountPayType)&&[2,4,6].includes(r.userAccountPayType)) {
              return '-'+t
            }
            return t
          }
        },{
          title: this.$t('交易方式'),
          dataIndex: 'payWay',
          align:"center",
          customRender:(t,r,index) => {
            if(isUndefined(payWayObj[t])) {
              return this.$t("其他")
            }
            return this.$t(payWayObj[t])
          }
        },{
          title: this.$t('订单号'),
          dataIndex: 'payOrderId',
          align:"center",
          },{
          title: this.$t('创建人'),
          dataIndex: 'createBy',
          align:"center",
          customRender:(t,r,index) => {
            // 撤销充值的记录只是修改记录的更新时间等信息，不增加记录，所以需要这样处理现实操作时间
            if(!isNull(r.updateBy)&&r.updateBy!="") {
              return r.updateBy
            }
            return t
          }
        },{
          title: this.$t('交易时间'),
          dataIndex: 'createTime',
          align:"center",
          customRender:(t,r,index) => {
            // 撤销充值的记录只是修改记录的更新时间等信息，不增加记录，所以需要这样处理现实操作时间
            if(!isNull(r.paymentTime)&&r.paymentTime!="") {
              return r.paymentTime
            }
            return t
          }
        },{
          title: this.$t('操作类型'),
          dataIndex: 'userAccountPayType',
          align:"center",
          fixed:"right",
          customRender:(t,r,index) => {
            if(isUndefined(payTypeObj[t])) {
              return this.$t("其他")
            }
            return this.$t(payTypeObj[t])
          }
          }
        ];
      },
      ReportedData() {
        return [
          {
            title:this.$t('用户编号'),
            align:"center",
            dataIndex:'userId'
          },{
            title:this.$t('用户姓名'),
            align:"center",
            dataIndex:'userName'
          },{
            title:this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
          },{
            title:this.$t('表端时间'),
            align:"center",
            dataIndex: 'meterTime',
          },{
            title:this.$t('上报时间'),
            align:"center",
            dataIndex: 'sysTime',
          },
          // {
          //   title:'信号强度',
          //   align:"center",
          //   dataIndex: 'meterSignalStrength'
          // },
          {
            title:this.$t('累计用量(m³)'),
            align:"center",
            dataIndex: 'meterTotalUse'
          },
          // {
          //   title:'结算日流量',
          //   align:"center",
          //   dataIndex: 'meterJsrUse'
          // },
          {
            title:this.$t('电池电压(V)'),
            align:"center",
            dataIndex: 'meterBatteryVoltage'
          },{
            title:this.$t('日冻结数据'),
            align:"center",
            dataIndex: 'meterDayUse'
          },
          // {
          //   title:'日最高流量',
          //   align:"center",
          //   dataIndex: 'meterDayHighFlow'
          // },
          {
            title:this.$t('存储状态'),
            align:"center",
            dataIndex: 'meterSaveFault',
            key:this.$t('存储故障'),
            customRender:(t,r,index) => {
              let data = {"0": this.$t("正常"),"1":this.$t("故障")}
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return data[t]
            }
          },
          // {
          //   title:'上报方式',
          //   align:"center",
          //   dataIndex: 'meterUpWay',
          //   key:'上报方式',
          //   customRender:function (t,r,index) {
          //     let data = {0: "定时上传",1:"上电上传",2:"手动上传",3:"故障上传"}
          //     if(isUndefined(typeof data[t])) {
          //       return "其他"
          //     }
          //     return data[t]
          //   }
          // },
          {
            title:this.$t('电池状态'),
            align:"center",
            dataIndex: 'meterBatteryStatus',
            key:this.$t('电池状态'),
            customRender:(t,r,index) => {
              let data = {"0": this.$t("正常"),"1":this.$t("欠压")}
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return data[t]
            }
          },{
            title:this.$t('阀门状态'),
            align:"center",
            dataIndex: 'meterValveStatus',
            key:this.$t('阀门状态'),
            customRender:(t,r,index) => {
              let data = Mn100FkStatusObj
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return this.$t(data[t])
            }
          },{
            title:this.$t('磁干扰'),
            align:"center",
            dataIndex: 'meterMagetic',
            key:this.$t('磁干扰'),
            customRender:(t,r,index) => {
              let data = {"1": this.$t("有"),"0":this.$t("正常")}
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return data[t]
            }
          },{
            title:this.$t('表端上报数据次数'),
            align:"center",
            dataIndex: 'meterUpTimes',
            key:this.$t('表端上报数据次数')
          },{
            title:this.$t('上报平台没有回应数'),
            align:"center",
            dataIndex: 'meterUpNoResponse',
            key:this.$t('上报平台没有回应数')
          },{
            title:this.$t('运营商'),
            align:"center",
            dataIndex: 'meterIotType',
            key:this.$t('运营商'),
            customRender:(t,r,index) => {
              let data = netTypeObj
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return this.$t(data[t])
            }
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:70,
            scopedSlots: { customRender: 'action' }
          }
        ];
      },
      changeMeterColumn() {
        return [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:(t,r,index) => {
                return parseInt(index)+1;
              },
              scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon'
              }
            },{
              title:this.$t('用户编号'),
              align:"center",
              dataIndex: 'userId'
            },{
              title:this.$t('用户姓名'),
              align:"center",
              dataIndex: 'userName'
            },{
              title:this.$t('用户地址'),
              align:"center",
              dataIndex: 'userAddr'
            },{
              title:this.$t('旧表编号'),
              align:"center",
              dataIndex: 'meterIdOld'
            },{
              title:this.$t('旧表累积量(m³)'),
              align:"center",
              dataIndex: 'meterOldSumFlowAfterChange'
            },{
              title:this.$t('旧表余额(元)'),
              align:"center",
              dataIndex: 'meterUserAccountNumAfterChange'
            },{
              title:this.$t('新表编号'),
              align:"center",
              dataIndex: 'meterIdNew'
            },{
              title:this.$t('新表起始读数'),
              align:"center",
              dataIndex: 'meterStartNum'
            },{
              title:this.$t('换表原因'),
              align:"center",
              dataIndex: 'meterChangeType',
              customRender: (text) => {
                //字典值替换通用方法
                return filterDictTextByCache('meterChangeType', text);
              }
            },{
              title:this.$t('操作时间'),
              align:"center",
              dataIndex: 'createTime'
            },{
              title:this.$t('操作人'),
              align:"center",
              dataIndex: 'createBy'
            },
            {
              title: this.$t('操作'),
              dataIndex: 'action',
              align:"center",
              fixed:"right",
              width:60,
              scopedSlots: { customRender: 'action' }
            }
        ];
      },
      transferMeterColumn() {
        return [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:(t,r,index) => {
                return parseInt(index)+1;
              },
              scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon'
              }
            },{
              title:this.$t('表编号'),
              align:"center",
              dataIndex: 'meterId'
            },{
              title:this.$t('用户编号'),
              align:"center",
              dataIndex: 'userId'
            },{
              title:this.$t('新用户姓名'),
              align:"center",
              dataIndex: 'userName'
            },{
              title:this.$t('旧用户姓名'),
              align:"center",
              dataIndex: 'oldUserName'
            },{
              title:this.$t('原用户手机号'),
              align:"center",
              dataIndex: 'oldUserPhone'
            },{
              title:this.$t('新身份证号'),
              align:"center",
              dataIndex: 'userIdNumber'
            },{
              title:this.$t('原身份证号'),
              align:"center",
              dataIndex: 'oldUserIdNumber'
            },{
              title:this.$t('新价格信息'),
              align:"center",
              dataIndex: 'newWtPrice',
              scopedSlots: { customRender: 'newWtPriceSlot' }
            },{
              title:this.$t('旧价格信息'),
              align:"center",
              dataIndex: 'oldWtPrice',
              scopedSlots: { customRender: 'oldWtPriceSlot' }
            },/*{
              title:'新类型',
              align:"center",
              dataIndex: 'userIdType',
              customRender:function (t,r,index) {
                let data = {"0": "企业","1":"自然人"}
                if(isUndefined(typeof data[t])) {
                  return "其他"
                }
                return data[t]
              }
            },{
              title:'原类型',
              align:"center",
              dataIndex: 'oldUserIdType',
              customRender:function (t,r,index) {
                let data = {"0": "企业","1":"自然人"}
                if(isUndefined(typeof data[t])) {
                  return "其他"
                }
                return data[t]
              }
            },{
              title:'原优惠信息',
              align:"center",
              dataIndex: 'oldUserFreeinfo',
              customRender: (text) => {
                //字典值替换通用方法
                return filterDictTextByCache('user_free_type', text);
              }
            },*/{
              title:this.$t('创建时间'),
              align:"center",
              dataIndex: 'createTime',
            },{
              title:this.$t('创建人'),
              align:"center",
              dataIndex: 'createBy'
            },
            {
              title: this.$t('操作'),
              dataIndex: 'action',
              align:"center",
              fixed:"right",
              width:100,
              scopedSlots: { customRender: 'action' }
            }
        ];
      },
      accountChangeColumn() {
        return [
            /*{
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },*/{
              title:this.$t('表编号'),
              align:"center",
              dataIndex: 'meterId',
              fixed: 'left',
              width: 120
            },{
              title:this.$t('用户编号'),
              align:"center",
              dataIndex: 'meterUserId',
              fixed: 'left',
              width:120
            },{
              title:this.$t('上期累计(m³)'),
              align:"center",
              dataIndex: 'userPreWaterNum',
              customRender:(t,r,index) => {
                return isNull(t)?'--':t;
              }
            },{
              title:this.$t('上期余额(元)'),
              align:"center",
              dataIndex: 'userPreAccountNum',
              customRender:(t,r,index) => {
                return isNull(t)?'--':t;
              }
            },{
              title:this.$t('本期累计(m³)'),
              align:"center",
              dataIndex: 'userNowWaterNum',
              customRender:(t,r,index) => {
                return isNull(t)?'--':t;
              }
            },{
              title:this.$t('本期使用(m³)'),
              align:"center",
              dataIndex: 'userChangeWaterNum',
              customRender:(t,r,index) => {
                return isNull(t)?'--':t;
              }
            },{
              title:this.$t('金额变动(元)'),
              align:"center",
              dataIndex: 'userChangeAccountNum',
              customRender:(t,r,index) => {
                if(!isUndefined(r.userAccountChangeType)&&[4,5,7,19].includes(r.userAccountChangeType)) {
                  return '-'+t
                }
                return t
              }
            },{
              title:this.$t('本期余额(元)'),
              align:"center",
              dataIndex: 'userNowAccountNum'
            },{
              title:this.$t('计费时间'),
              align:"center",
              dataIndex: 'createTime',
            },{
              title:this.$t('操作人'),
              align:"center",
              dataIndex: 'createBy'
            },{
              title:this.$t('备注'),
              align:"center",
              dataIndex: 'changeRemark'
            },{
              title:this.$t('操作类型'),
              align:"center",
              dataIndex: 'userAccountChangeType',
              fixed: 'right',
              customRender:(t,r,index) => {
                let obj = accountChangeObj
                if(isUndefined(obj[t])) {
                  return this.$t("其他")
                }
                return this.$t(obj[t])
              }
            }/*,
            {
              title: '操作',
              dataIndex: 'action',
              align:"center",
              fixed:"right",
              width:100,
              scopedSlots: { customRender: 'action' }
            }*/
        ];
      },
      DailyStatement() {
        return [
          {
            title:this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId'
          },{
            title:this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId'
          },{
            title:this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName'
          },{
            title:this.$t('用户电话'),
            align:"center",
            dataIndex: 'userPhone'
          },{
            title:this.$t('用户地址'),
            align:"center",
            dataIndex: 'userAddr'
          },{
            title:this.$t('日用量(m³)'),
            align:"center",
            dataIndex: 'dayUse'
          },{
            title:this.$t('表口径'),
            align:"center",
            dataIndex: 'mtCaliber',
            customRender: (text,row) => {
              return 'DN'+text;
            }
          },{
            title:this.$t('上报月份'),
            align:"center",
            dataIndex: 'reportMonth'
          },{
            title:this.$t('报表日期'),
            align:"center",
            dataIndex: 'reportDate'
          }
        ];
      },
      OrderManagement() {
        return [
          {
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId'
          },{
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName'
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId'
          },{
            title: this.$t('表安装地址'),
            align:"center",
            dataIndex: 'userMeterAddr'
          },{
            title: this.$t('表类型'),
            align:"center",
            dataIndex: 'meterType',
            customRender:(t,r,index) => {
              let data = meterTypeObj
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return this.$t(data[t])
            }
          },{
            title: this.$t('命令标识'),
            align:"center",
            dataIndex: 'cmd',
            customRender:(text) => {
              return this.$t(dataFlagObj[text])
            }
          },{
            title: this.$t('命令ID'),
            align:"center",
            dataIndex: 'commandId'
          },{
            title: this.$t('通讯状态'),
            align:"center",
            dataIndex: 'status',
            customRender:(t,r,index) => {
              let data = reportStatusObj
              if(isUndefined(data[t])) {
                return this.$t("其他")
              }
              return this.$t(data[t])
            }
          },{
            title: this.$t('发送时间'),
            align:"center",
            dataIndex: 'sendTime'
          },{
            title: this.$t('接收回应时间'),
            align:"center",
            dataIndex: 'receiveTime'
          },{
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:70,
            scopedSlots: { customRender: 'action' }
          }
        ];
      },
      // 表头
      partcolumns() {
        return [
            {
                title: '#',
                dataIndex: '',
                key:'rowIndex',
                width:60,
                align:"center",
                customRender:(t,r,index) => {
                return parseInt(index)+1;
                }
            },{
                title: this.$t('命令类型'),
                align:"center",
                dataIndex: 'cmd',
                customRender:(text) => {
                return this.$t(dataFlagObj[text])
                }
            },{
                title: this.$t('表类型'),
                align:"center",
                dataIndex: 'mtName',
                // customRender:function (t,r,index) {
                //     let data = meterTypeObj
                //     if(isUndefined(data[t])) {
                //         return "其他"
                //     }
                //     return data[t]
                // }
            },{
                title: this.$t('表编号'),
                align:"center",
                dataIndex: 'meterId'
            },{
                title: this.$t('发送状态'),
                align:"center",
                dataIndex: 'status',
                customRender:(t,r,index) => {
                if(isUndefined(reportStatusObj[t])) {
                    return this.$t("其他")
                }
                return this.$t(reportStatusObj[t])
                }
            },{
                title: this.$t('发送时间'),
                align:"center",
                dataIndex: 'sendTime'
            },{
                title: this.$t('接收回应时间'),
                align:"center",
                dataIndex: 'receiveTime'
            },/*{
                title: '指令标记帧',
                align:"center",
                dataIndex: 'mid'
            },*/{
                title: this.$t('操作'),
                dataIndex: 'action',
                align:"center",
                flex: "right",
                width: 147,
                scopedSlots: { customRender: 'action' },
            }
        ];
      },
      // i18n：校验消息使用 computed 以响应语言切换
      validatorRules() {
        return {
          meterId:{   //表编号
            rules:[
              {required: true, len:14 , message: this.$t('请输入表编号!')},
              {validator: this.validatePlanName},
            ]
          },
          userAreaId:{  // 区域id
            rules:[
              {required:true, message:this.$t('请输入用户区域id！')},
            ]
          },
          userPriceCode:{  //价格名称
            rules:[
              {required:true, message:this.$t('请选择价格编码！')},
            ]
          },
        }
      },
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      
    },
    methods: {
      handleChange(value) {
        this.genre.type = value + '';
        console.log(this.genre.type + '');
        console.log(`selected ${value}`);
      },
      getQueryParams() {
      //获取查询条件
      let sqp = {}
      if(this.superQueryParams){
        sqp['superQueryParams']=encodeURI(this.superQueryParams)
        sqp['superQueryMatchType'] = this.superQueryMatchType
      }
      var param = Object.assign(sqp, this.queryParam, this.isorter ,this.filters);
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
      },
      loadData(arg) {
        console.log(arg);
        if(!this.url.list){
            this.$message.error(this.$t("请设置url.list属性!"))
            return
        }
        if (arg === 1) {
        this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        params.userAccountPayType = this.genre.type;
        params.userKeyId = this.model.id;
        console.log(params);
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
          this.dataSource = res.result.records;
          this.ipagination.total = res.result.total;
          }
          if(res.code===510){
          this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      searchQuery() {
        this.loadData(1);
      },
      searchReset() {
        this.genre = [];
        this.queryParam = {};
        this.loadData(1);
      },
      searchQueryChangeMeterRecord() {
          this.queryChangeMeterDataRecord(1)
      },
      searchQueryAccountChangeRecord() {
          this.queryAccountChangeDataRecord(1)
      },
      searchResetChangeMeterRecord() {
        this.changeMeterDate = [];
        this.queryParamChangeMeter = this.$options.data.call(this).queryParamChangeMeter;
        
        this.queryChangeMeterDataRecord(1);
      },
      searchResetAccountChangeRecord() {
        this.accountChangeDate = [];
        this.queryParamAccountChange = this.$options.data.call(this).queryParamAccountChange;
        
        this.queryAccountChangeDataRecord(1);
      },
      queryUserDetailInfo() {  //用户详情
        var params = {};
        params.id = this.model.id;
        console.log(params);
        this.loading = true;
        getAction(this.url.queryUserDetailInfoById, params).then((res) => {
          if(res.success){
          this.queryUserDetailInfoById = res.result;
          console.log(this.queryUserDetailInfoById);
          }
          this.loading = false;
        })
      },
      queryUpDataRecord(arg) {  //上报数据
      console.log(arg);
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        var params = {};
        params.pageNo = this.ipagination.current;
        params.pageSize = this.ipagination.pageSize;
        params.userId = this.model.userId;
        console.log(params);
        this.loading = true;
        getAction(this.url.UpDataRecord, params).then((res) => {
          if(res.success){
          this.dataSource = res.result.records;
          this.ipagination.total = res.result.total;
          }
          this.loading = false;
        })
      },
      queryChangeMeterDataRecord(arg) {  //换表数据
      console.log(arg);
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        var params = {...this.queryParamChangeMeter};
        params.pageNo = this.ipagination.current;
        params.pageSize = this.ipagination.pageSize;
        params.userId = this.model.userId;
        console.log(params);
        this.loading = true;
        getAction(this.url.changeMeterDataRecord, params).then((res) => {
          if(res.success){
          this.dataSource = res.result.records;
          this.ipagination.total = res.result.total;
          }
          this.loading = false;
        })
      },
      queryTransferMeterDataRecord(arg) {  //过户
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        let params = {}
        params.pageNo = this.ipagination.current;
        params.pageSize = this.ipagination.pageSize;
        params.userId = this.model.userId;
        console.log(params);
        this.loading = true;
        getAction(this.url.transferMeterDataRecord, params).then((res) => {
          if(res.success){
          this.dataSource = res.result.records;
          this.ipagination.total = res.result.total;
          }
          this.loading = false;
        })
      },
      queryAccountChangeDataRecord(arg) {  //扣费数据
      console.log(arg);
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        var params = {...this.queryParamAccountChange};
        params.pageNo = this.ipagination.current;
        params.pageSize = this.ipagination.pageSize;
        params.userKeyId = this.model.id;
        this.loading = true;
        getAction(this.url.accountChangeDataRecord, params).then((res) => {
          if(res.success){
          this.dataSource = res.result.records;
          this.ipagination.total = res.result.total;
          }
          this.loading = false;
        })
      },
      querycommandlist(arg) {  //命令管理
        if (arg === 1) {
          this.ipaginationmanagement.current = 1;
        }
        let params = {}
        params.pageNo = this.ipagination.current;
        params.pageSize = this.ipagination.pageSize;
        params.userId = this.model.userId;
        console.log(params);
        this.loading = true;
        getAction(this.url.commandlist, params).then((res) => {
          if(res.success){
          this.dataSource = res.result.records;
          this.ipagination.total = res.result.total;
          }
          this.loading = false;
        })
      },
      handleTableChange(pagination, filters, sorter) {
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = pagination;
        this.loadData();
      },
      handleTableChangereported(ipagination, filters, sorter) {
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
          this.ipagination = ipagination;
          this.queryUpDataRecord();
      },
      handleTableChangeMeter(ipagination, filters, sorter) {
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
          this.ipagination = ipagination;
          this.queryChangeMeterDataRecord();
      },
      handleTableChangeTransferMeter(ipagination, filters, sorter) {
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = ipagination;
        this.queryTransferMeterDataRecord()
      },
      handleTableChangeAccountChange(ipagination, filters, sorter) {
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = ipagination;
        this.queryAccountChangeDataRecord()
      },
      handleTableChanmanagement(ipagination, filters, sorter) {
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
          this.ipagination = ipagination;
          this.querycommandlist()
      },
      loadTreeData() {
        console.log("查询区域")
        var that = this;
        queryAreaTreeList().then((res) => {
          if (res.success) {
            //部门全选后，再添加部门，选中数量增多
            that.treeData = []
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i]
              that.treeData.push(temp)
            }
          }
        })
      },
      changeTab(key) {
        console.log(key);
        this.dataSource = [];
        this.ipagination = this.$options.data.call(this).ipagination;
        if (this.activeKey == 1) {
          this.queryUserDetailInfo();
        }else if (this.activeKey == 2) {
          this.genre = [];
          this.loadData(1);
        }else if (this.activeKey == 3) {
            // 换表记录
            this.queryChangeMeterDataRecord(1)
            //this.queryUpDataRecord(1);
        }else if (this.activeKey == 4) {
            // 过户记录
          this.queryTransferMeterDataRecord(1);
        }else if (this.activeKey == 5) {
          this.querycommandlist(1);
        }else if(this.activeKey == 6) {
          this.queryAccountChangeDataRecord(1);
        }else if(this.activeKey == 7){
          this.getPart();
        }
      },
      handleDetails(record){
        this.$refs.modalOldForm.edit(record);
        this.$refs.modalOldForm.title=this.$t("详情");
        this.$refs.modalOldForm.disableSubmit = true;
      },
      handletransferMeterDetail(record){
        this.$refs.transferMeterModal.edit(record);
        this.$refs.transferMeterModal.title=this.$t("详情");
        this.$refs.transferMeterModal.disableSubmit = true;
      },
      handleParticulars(record){
        this.$refs.upDataModal.edit(record);
        this.$refs.upDataModal.title=this.$t("详情");
        this.$refs.upDataModal.disableSubmit = true;
      },
      handleDet(record){
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title=this.$t("详情");
        this.$refs.modalForm.disableSubmit = true;
      },
      handleChangeMeterModal(record) {
        this.$refs.changeMeterModal.edit(record);
        this.$refs.changeMeterModal.title=this.$t("详情");
        this.$refs.changeMeterModal.disableSubmit = true;
      },
      onDateRangeChange(value, dateStrings) {
        if(dateStrings[0]!=''&&dateStrings[1]!='') {
          this.queryParamChangeMeter.beginDate = dateStrings[0]+' 00:00:00';
          this.queryParamChangeMeter.endDate = dateStrings[1]+' 23:59:59';
        }else{
          if(this.queryParamChangeMeter['beginDate']) {
            delete this.queryParamChangeMeter['beginDate']
          }
          if(this.queryParamChangeMeter['endDate']) {
            delete this.queryParamChangeMeter['endDate']
          }
        }
      },
      onDateRangeChangeAccountChange(value, dateStrings) {
        if(dateStrings[0]!=''&&dateStrings[1]!='') {
          this.queryParamAccountChange.beginDate = dateStrings[0];
          this.queryParamAccountChange.endDate = dateStrings[1];
        }else{
          if(this.queryParamAccountChange['beginDate']) {
            delete this.queryParamAccountChange['beginDate']
          }
          if(this.queryParamAccountChange['endDate']) {
            delete this.queryParamAccountChange['endDate']
          }
        }
      },
      modalOldForm() {
      },
      modalFormOk() {
      },
      upDataModalOk() {
      },
      add () {
        this.visible=true
        this.edit({});
      },
      edit (record) {
        this.visible=true
        this.model = Object.assign({}, record);
        this.visible = true;
        this.loadTreeData();
        this.queryUserDetailInfo();
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel () {
        this.shut();
        this.close()
      },
      shut(){    //关闭按钮
        this.activeKey ='1';
        this.genre = [];
        this.dataSource=[];
        this.ipagination=this.$options.data.call(this).ipagination;
        console.log(this.activeKey);
      },
      handleExportXlsUserPayRecord(fileName) {
        // 交易记录
        let params = this.getQueryParams();
        params.userAccountPayType = this.genre.type;
        params.userKeyId = this.model.id;
        let url = this.url.exportXlsUrlUserPayRecord;
        this.handleExportXls(fileName,url,params)
      },
      handleExportXlsTransferMeterRecord(fileName) {
        // 过户记录
        let params = {...this.queryParamAccountChange};
        params.userId = this.model.userId;
        let url = this.url.exportXlsUrlTransferMeterDataRecord;
        this.handleExportXls(fileName,url,params)
      },
      handleExportXlsAccountChangeRecord(fileName) {
        // 扣费记录
        let params = {...this.queryParamAccountChange};
        params.userKeyId = this.model.id;
        let url = this.url.exportXlsUrlAccountChangeDataRecord;
        this.handleExportXls(fileName,url,params)
      },
      handleExportXlsChangeMeterRecord(fileName) {
        // 换表记录
        let params = {...this.queryParamChangeMeter};
        params.userId = this.model.userId;
        let url = this.url.exportXlsUrlchangeMeterDataRecord;
        this.handleExportXls(fileName,url,params)
      },
      handleExportXls(fileName,url,param){
        if(!fileName || typeof fileName != "string"){
          fileName = this.$t("导出文件")
        }
        downFile(url,param).then((data)=>{
          if (!data) {
            this.$message.warning(this.$t("文件下载失败"))
            return
          }
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(new Blob([data],{type: 'application/vnd.ms-excel'}), fileName+'.xls')
          }else{
            let url = window.URL.createObjectURL(new Blob([data],{type: 'application/vnd.ms-excel'}))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName+'.xls')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
          }
        })
      },
      handleDetail1(record) {
          if(record.meterType == '15') {
              this.$refs.usModalForm.edit(record);
              this.$refs.usModalForm.title = this.$t('命令详情');
              this.$refs.usModalForm.disableSubmit = true;
              }else{
              this.$refs.modalForm1.edit(record);
              this.$refs.modalForm1.title = this.$t('命令详情');
              this.$refs.modalForm1.disableSubmit = true;
          }
      },
      getPart(arg){
        if (arg === 1) {
          this.ipagination1.current = 1;
        }
        var params = {};
        params.pageNo = this.ipagination1.current;
        params.pageSize = this.ipagination1.pageSize;
        params.meterId = this.model.meterId;
        console.log(params);
        this.loading = true;
        getAction(this.url.partlist,params).then((res) => {
            if (res.success) {
            this.dataSource = res.result.records;
            this.ipagination1.total = res.result.total;
            }
            if(res.code===510){
            this.$message.warning(res.message)
            }
            this.loading = false;
        })
      },
      handleTableChange1(pagination, filters, sorter){
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination1 = pagination;
        this.getPart();
      }
    },
  }
</script>
<style scoped>
.detail-list >>> .content{
  line-height: normal;
}
</style>